module.exports = __webpack_public_path__ + "img/city_box1.aef7e705.png";